import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Question from './Question';
import Footer from '../../components/globales/Footer';
import Loading from '../../components/globales/Loading';
import API_BASE_URL from '../../apiConfig';
import { Card, Modal, Button, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';

function EncuestaConductor() {
	const { token } = useParams();
	const [manifiesto, setManifiesto] = useState();
	const [empresa, setEmpresa] = useState();
	const [nitEmpresa, setNitEmpresa] = useState();
	const [conductor, setConductor] = useState();
	const [nombreConductor, setNombreConductor] = useState();
	const [ruta, setRuta] = useState();
	const [vehiculo, setVehiculo] = useState();
	const [preguntas, setPreguntas] = useState([]);
	const [respuestas, setRespuestas] = useState([]);
	const [observacionesPreguntas, setObservacionesPreguntas] = useState([]);
	const [observaciones, setObservaciones] = useState('');
	const [loading, setLoading] = useState(true);
	const [paginaActual, setPaginaActual] = useState(1);
	const [resultadoEnvio, setResultadoEnvio] = useState(null);
	const [mensaje, setMensaje] = useState('Cargando Preguntas...');
	const [erroresValidacion, setErroresValidacion] = useState([]);
	const preguntasPorPagina = 15;

	// Estados para cámara y evidencia
	const [fileupload, setFile] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const videoRef = useRef(null);
	const canvasRef = useRef(null);
	const [facingMode, setFacingMode] = useState('environment');
	const streamRef = useRef(null);

	// Cargar preguntas al montar
	useEffect(() => {
		async function fetchQuestions() {
			try {
				const resp = await axios.get(`${API_BASE_URL}/preguntas/${token}`);
				const data = resp.data.data;
				setNitEmpresa(data.nit_empesa);
				setEmpresa(data.nombre_empresa);
				setManifiesto(data.manifiesto);
				setConductor(data.conductor);
				setNombreConductor(data.nombre_conductor);
				setRuta(data.ruta);
				setVehiculo(data.placa);

				// Agrupar y aplanar preguntas
				const grouped = data.preguntar.reduce((acc, q) => {
					const opts = (q.data || [])
						.map(o => ({
							code: o.codigo,
							text: o.opcion,
							aplicaObservacion: o.aplica_observacion
						}))
						.sort((a, b) => a.text.localeCompare(b.text));
					const p = {
						id: q.codigo,
						text: q.enunciado,
						options: opts,
						defaultOption: opts[0]?.code || null,
						codigo_tema: q.codigo_tema,
						nombre_tema: q.nombre_tema
					};
					if (!acc[q.codigo_tema]) {
						acc[q.codigo_tema] = { nombre_tema: q.nombre_tema, preguntas: [] };
					}
					acc[q.codigo_tema].preguntas.push(p);
					return acc;
				}, {});
				const flat = Object.values(grouped)
					.flatMap(g => [{ esTitulo: true, nombre_tema: g.nombre_tema }, ...g.preguntas]);
				setPreguntas(flat);
				const solo = flat.filter(p => !p.esTitulo);
				setRespuestas(solo.map(q => q.defaultOption));
				setObservacionesPreguntas(Array(solo.length).fill(''));
			} catch (err) {
				console.error('Error cargando preguntas:', err);
				setResultadoEnvio({ success: false, message: err.response?.data?.message || err.message });
			} finally {
				setLoading(false);
			}
		}
		fetchQuestions();
	}, [token]);

	useEffect(() => {
		window.scrollTo(0, 0);
		// Limpiar errores de validación al cambiar de página
		setErroresValidacion([]);
	}, [paginaActual]);

	// Función unificada para validar observaciones 
	const validarObservacionesObligatorias = (opciones = {}) => {
		const {
			validarTodasLasPaginas = false,
			paginaEspecifica = null
		} = opciones;

		const errores = [];
		const soloPreguntas = preguntas.filter(p => !p.esTitulo);

		// Determinar qué páginas validar
		let paginasAValidar = [];
		if (validarTodasLasPaginas) {
			// Validar todas las páginas
			for (let i = 1; i <= totalPaginas; i++) {
				paginasAValidar.push(i);
			}
		} else if (paginaEspecifica) {
			// Validar página específica
			paginasAValidar.push(paginaEspecifica);
		} else {
			// Validar solo página actual
			paginasAValidar.push(paginaActual);
		}

		// Validar observaciones por página
		paginasAValidar.forEach(numeroPagina => {
			// Calcular el rango de preguntas para la página
			let contadorPreguntas = 0;
			let inicioRango = -1;
			let finRango = -1;
			
			for (let i = 0; i < preguntas.length; i++) {
				const paginaPregunta = Math.floor(i / preguntasPorPagina) + 1;
				if (!preguntas[i].esTitulo) {
					if (paginaPregunta === numeroPagina) {
						if (inicioRango === -1) inicioRango = contadorPreguntas;
						finRango = contadorPreguntas;
					}
					contadorPreguntas++;
				}
			}
			
			// Validar las preguntas de esta página
			if (inicioRango !== -1 && finRango !== -1) {
				for (let index = inicioRango; index <= finRango; index++) {
					const pregunta = soloPreguntas[index];
					const respuestaSeleccionada = respuestas[index];
					const opcionSeleccionada = pregunta.options.find(option => option.code === respuestaSeleccionada);
					if (opcionSeleccionada && opcionSeleccionada.aplicaObservacion === true) {
						const observacion = observacionesPreguntas[index];
						if (!observacion || observacion.trim() === '') {
							errores.push({
								indice: index,
								pregunta: pregunta.text,
								mensaje: 'La observación es obligatoria para esta respuesta.',
								tipo: 'observacion',
								pagina: numeroPagina
							});
						}
					}
				}
			}
		});

		return errores;
	};

	// Función para verificar si una pregunta tiene error de validación
	const tieneErrorValidacion = (indice) => {
		return erroresValidacion.some(error => error.indice === indice);
	};

	const totalPaginas = Math.ceil(preguntas.length / preguntasPorPagina);
	const indice = (paginaActual - 1) * preguntasPorPagina;
	const paginacion = preguntas.slice(indice, indice + preguntasPorPagina);

	const setAnswer = (i, resp) => {
		const copy = [...respuestas];
		copy[i] = resp;
		setRespuestas(copy);
	};

	const setObservacion = (i, obs) => {
		const copy = [...observacionesPreguntas];
		copy[i] = obs;
		setObservacionesPreguntas(copy);
	};

	const enviarRespuestas = async () => {
		// Validar TODAS las observaciones obligatorias 
		const erroresValidacion = validarObservacionesObligatorias({
			validarTodasLasPaginas: true
		});
		
		if (erroresValidacion.length > 0) {
			setErroresValidacion(erroresValidacion);
			
			// Si hay errores de observaciones, navegar a la primera página con error
			const primerError = erroresValidacion.find(error => error.tipo === 'observacion');
			if (primerError && primerError.pagina) {
				setPaginaActual(primerError.pagina);
				toast.error('Hay observaciones obligatorias pendientes.');
				return;
			}
			
			return;
		}
		// Limpiar errores si la validación es exitosa
		setErroresValidacion([]);
		setMensaje('Enviando Respuestas...');
		setLoading(true);

		// Crear FormData para enviar tanto respuestas como evidencia
		const formData = new FormData();
		const respuesta = preguntas
				.filter((question, index) => !question.esTitulo)
				.map((question, index) => ({
					code: question.id,
					response: [respuestas[index]],
					observaciones: observacionesPreguntas[index]
				}));

		formData.append('questions', JSON.stringify(respuesta));

		// Agregar la imagen si existe (usando el mismo tag que Novedades.jsx)
		if (fileupload) {
			formData.append('novedadImagen', fileupload);
		}

		// Agregar referencia para la evidencia
		formData.append('referencia', token);

		// Agregar observaciones generales
		formData.append('observaciones', observaciones);

		console.log(formData.get('questions')); 
		console.log(formData.get('imagen'));
		console.log(formData.get('referencia'));
		console.log(formData.get('observaciones'));

		try {
			const response = await axios.post(`${API_BASE_URL}/procesarPreguntas`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});
			setResultadoEnvio({ success: true, message: response.data.message });
		} catch (err) {
			console.error('Error al enviar respuestas:', err);
			setResultadoEnvio({ success: false, message: err.response?.data?.message || err.message });
			console.log(err.message);
		} finally {
			setLoading(false);
		}
	};

	const pagAnterior = () => {
		if (paginaActual > 1) {
			// Limpiar errores al retroceder
			setErroresValidacion([]);
			setPaginaActual(paginaActual - 1);
		}
	};
	// Formatear fecha y hora DD/MM/AAAA HH:mm:ss
	function formatDateTime(date) {
		const pad = n => n.toString().padStart(2, '0');
		return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} `
			 + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
	}

	// Iniciar cámara
	const startCamera = useCallback(async () => {
		try {
			const mediaStream = await navigator.mediaDevices.getUserMedia({
				video: { facingMode }
			});
			streamRef.current = mediaStream;
			if (videoRef.current) {
				videoRef.current.srcObject = mediaStream;
				await videoRef.current.play();
			}
		} catch (err) {
			console.error('Error cámara:', err);
			toast.error('No se pudo acceder a la cámara');
		}
	}, [facingMode]);

	// Detener cámara
	const stopCamera = useCallback(() => {
		if (streamRef.current) {
			streamRef.current.getTracks().forEach(t => t.stop());
			streamRef.current = null;
		}
	}, []);

	useEffect(() => {
		if (showModal) startCamera();
		else stopCamera();
	}, [showModal, startCamera, stopCamera]);

	// Capturar foto, superponer fecha/hora, comprimir, enviar y ocultar modal
	const capturePhoto = () => {
		const canvas = canvasRef.current;
		const video = videoRef.current;
		if (!canvas || !video) return;

		const ctx = canvas.getContext('2d');
		canvas.width = video.videoWidth;
		canvas.height = video.videoHeight;
		ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

		const fh = formatDateTime(new Date());
		ctx.font = '20px Arial';
		ctx.fillStyle = 'white';
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.strokeText(fh, 10, canvas.height - 20);
		ctx.fillText(fh, 10, canvas.height - 20);

		canvas.toBlob(blob => {
			if (!blob) return;
			const file = new File([blob], `foto-${Date.now()}.jpg`, { type: 'image/jpeg' });
			setFile(file);
			toast.success('Imagen capturada correctamente');
			setShowModal(false);
		}, 'image/jpeg', 0.9);
	};

	// Función para eliminar la foto capturada
	const eliminarFoto = () => {
		setFile(null);
		toast.info('Foto eliminada. Puede tomar una nueva foto.');
	};

	// Alternar cámara frontal/trasera
	const toggleCamera = () => {
		setFacingMode(prev => prev === 'environment' ? 'user' : 'environment');
	};

	const pagSiguiente = () => {
		if (paginaActual < totalPaginas) {
			// Validar observaciones obligatorias de la página actual antes de avanzar
			const erroresValidacion = validarObservacionesObligatorias();
			if (erroresValidacion.length > 0) {
				setErroresValidacion(erroresValidacion);
				return; // No avanzar si hay errores
			}
			// Limpiar errores si la validación es exitosa
			setErroresValidacion([]);
			setPaginaActual(paginaActual + 1);
		}
	};

	return (
		<>
			{loading ? (
				<div className='load'>
					<Loading mensaje={mensaje} />
				</div>
			) : (
				<div>
					{resultadoEnvio ? ( 
						<>
							<div className="header-container">
								<img src="/camion2.jpg" alt="Camión" className="header-image" />
								<div className="header-title">Inspección Preoperacional</div>
							</div>
							<div className="container content-container">
								{resultadoEnvio.success ? (
									<div className="alert alert-success">
										{resultadoEnvio.message || 'Respuestas enviadas exitosamente'}
									</div>
								) : (
									<div className="alert alert-danger">
										{resultadoEnvio.message || 'Error al enviar respuestas'}
									</div>
								)}
							</div>
						</>
					) : (
						<div>
							<div className="header-container">
								<img src="/camion2.jpg" alt="Camión" className="header-image" />
								<div className="header-title">Inspección Preoperacional</div>
							</div>
							<div className="container content-container">
								{preguntas.length > 0 && (
									<div>
										{paginaActual === 1 && (
											<>
												<Card className="shadow card-custom-bg">
													<Card.Body>
														<center>
															<h5 style={{ marginTop: '15px' }}><strong>Datos Empresa</strong></h5>
														</center>
														<ul className="list-group list-group-flush">
															<li className="list-group-item"><strong>Nit: </strong>{nitEmpresa}</li>
															<li className="list-group-item"><strong>Empresa: </strong>{empresa}</li>
														</ul>
														<hr/>
														<center>
															<h5 style={{ marginTop: '15px' }}><strong>Datos Viaje</strong></h5>
														</center>
														<ul className="list-group list-group-flush">
															<li className="list-group-item"><strong>Manifiesto: </strong>{manifiesto}<span style={{ marginLeft: '20px' }}><strong>Vehiculo: </strong>{vehiculo}</span></li>
															<li className="list-group-item"><strong>Conductor: </strong>{conductor} {nombreConductor}</li>
															<li className="list-group-item"><strong>Ruta: </strong>{ruta}</li>
														</ul>
													</Card.Body>
												</Card>
												<center>
													<h5 style={{ marginTop: '15px' }}><strong>Encuesta</strong></h5>
												</center>
											</>
										)}
										{paginacion.map((item, index) => {
											if (item.esTitulo) {
												return (
													<center key={`titulo-${index}`}>
														<h6><strong>{item.nombre_tema}</strong></h6>
													</center>
												);
											} else {
											
												const preguntaIndexGlobal = indice + index;
												const ajustePorTitulos = preguntas.slice(0, preguntaIndexGlobal).filter(p => p.esTitulo).length;
												const preguntaIndex = preguntaIndexGlobal - ajustePorTitulos;

												return (
													<div key={`pregunta-${item.id}`} className={tieneErrorValidacion(preguntaIndex) ? 'border border-danger p-2 rounded mb-2' : ''}>
														{tieneErrorValidacion(preguntaIndex) && (
															<div className="alert alert-danger py-1 mb-2">
																<small>Esta pregunta requiere observación </small>
															</div>
														)}
														<Question
															question={item}
															answer={respuestas[preguntaIndex]}
															observation={observacionesPreguntas[preguntaIndex]}
															setAnswer={(response) => {
																setAnswer(preguntaIndex, response);
																// Limpiar error de validación cuando se cambia la respuesta
																if (tieneErrorValidacion(preguntaIndex)) {
																	setErroresValidacion(prev => prev.filter(error => error.indice !== preguntaIndex));
																}
															}}
															setObservacion={(observation) => {
																setObservacion(preguntaIndex, observation);
																// Limpiar error de validación cuando se añade observación
																if (observation && observation.trim() !== '' && tieneErrorValidacion(preguntaIndex)) {
																	setErroresValidacion(prev => prev.filter(error => error.indice !== preguntaIndex));
																}
															}}
														/>
													</div>
												);
											}
										})}
										{paginaActual === totalPaginas && (
											<div>
												{/* --- SECCIÓN: Agregar Evidencia --- */}
												<div className="border rounded p-3 mt-3 mb-3">
													{/* Header del cajón */}
													<div className="d-flex justify-content-between align-items-center mb-3">
														<span>Agregar Evidencia </span>
														{!fileupload && (
															<Button
																className="px-3 py-1"
																onClick={() => setShowModal(true)}
															>
																<span
																	className="material-icons"
																	style={{ verticalAlign: 'middle' }}
																>
																	photo_camera
																</span>{' '}
																Tomar Foto
															</Button>
														)}
													</div>

													{/* Previsualización de la imagen dentro del cajón */}
													{fileupload && (
														<div className="text-center">
															<img
																src={URL.createObjectURL(fileupload)}
																alt="Imagen Capturada"
																className="img-fluid rounded border border-success"
																style={{ maxHeight: '300px' }}
															/>
															<div className="text-success mt-2">
																<small><strong>✓ Evidencia cargada correctamente</strong></small>
															</div>
															<div className="mt-2">
																<Button 
																	variant="outline-danger" 
																	size="sm" 
																	onClick={eliminarFoto}
																	className="me-2 d-inline-flex align-items-center"
																>
																	<span className="material-icons me-1" style={{ fontSize: '16px', lineHeight: '1' }}>delete</span>
																	Eliminar Foto
																</Button>
																<Button 
																	variant="outline-secondary" 
																	size="sm" 
																	onClick={() => setShowModal(true)}
																	className="d-inline-flex align-items-center"
																>
																	<span className="material-icons me-1" style={{ fontSize: '16px', lineHeight: '1' }}>photo_camera</span>
																	Tomar Nueva Foto
																</Button>
															</div>
														</div>
													)}
												</div>

												{/* Modal de Cámara */}
												<Modal
													show={showModal}
													onHide={() => setShowModal(false)}
													centered
													size="lg"
												>
													<Modal.Body className="text-center p-3">
														<div style={{ width: '90vw', maxWidth: '700px', margin: 'auto' }}>
															<video
																ref={videoRef}
																autoPlay
																playsInline
																className="w-100 rounded"
																style={{ height: '60vh', border: '3px solid #007bff' }}
															/>
															<canvas ref={canvasRef} style={{ display: 'none' }} />
														</div>
														<Row className="d-flex justify-content-center align-items-center mt-3">
															<Col xs="auto">
																<Button variant="info" className="me-4" onClick={toggleCamera}>
																	<span className="material-icons">
																		flip_camera_android
																	</span>
																</Button>
															</Col>
															<Col xs="auto">
																<Button variant="success" className="me-4" onClick={capturePhoto}>
																	<span className="material-icons">
																		photo_camera
																	</span>
																</Button>
															</Col>
															<Col xs="auto">
																<Button variant="danger" onClick={() => setShowModal(false)}>
																	<span className="material-icons">close</span>
																</Button>
															</Col>
														</Row>
													</Modal.Body>
												</Modal>
											</div>
										)}
										{paginaActual === totalPaginas && (
											<div>
												<div className="form-floating">
													<textarea
														className="form-control"
														placeholder="Observaciones"
														id="observaciones"
														value={observaciones}
														onChange={(e) => setObservaciones(e.target.value)}
													></textarea>
													<label htmlFor="floatingTextarea">Observaciones Generales</label>
												</div>
											</div>
										)}
										{preguntas.length > preguntasPorPagina && (
											<div>
												<br />
												<div className="pagination-indicators">
													{Array.from({ length: totalPaginas }, (_, i) => (
														<span key={i} className={`dot ${paginaActual === i + 1 ? 'active' : ''}`}></span>
													))}
												</div>
												<div className="pagination-buttons d-flex justify-content-center mt-4">
													<button onClick={pagAnterior} className="btn btn-secondary mx-2" disabled={paginaActual === 1}>Anterior</button>
													<button onClick={pagSiguiente} className="btn btn-secondary mx-2" disabled={paginaActual === totalPaginas}>Siguiente</button>
												</div>
											</div>
										)}
										{paginaActual === totalPaginas && (
											<div className="submit-button text-center">
												<button onClick={enviarRespuestas} className="btn custom-submit-button mt-4">Registrar Respuestas</button>
											</div>
										)}
									</div>
								)}
							</div>
						</div>
					)}
					<Footer />
				</div>
			)}
		</>
	);
}

export default EncuestaConductor;
